import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { orpc } from "@/orpc/client";
import { Finances } from "@/pages/finances/Finances";
import { FinancesPageSkeleton } from "@/pages/finances/FinancesPageSkeleton";

export const FinancesSearchSchema = z.object({
	// Tab
	tab: z.enum(["earnings", "payouts", "payment_methods"]).default("earnings"),
	// Payout filters
	pPartner: z.string().optional(),
	pStatus: z.string().optional(),
	pMin: z.coerce.number().int().optional(),
	pMax: z.coerce.number().int().optional(),
	pAfter: z.string().optional(),
	pBefore: z.string().optional(),
	pPaidAfter: z.string().optional(),
	pPaidBefore: z.string().optional(),
	pc: z.string().array().default([]),
	// Earning filters
	eApp: z.string().optional(),
	ePartner: z.string().optional(),
	eStatus: z.string().optional(),
	eMin: z.coerce.number().int().optional(),
	eMax: z.coerce.number().int().optional(),
	eAfter: z.string().optional(),
	eBefore: z.string().optional(),
	ec: z.string().array().default([]),
	// Payment methods
	add: z.coerce.boolean().optional(),
	successRedirect: z.string().optional(),
});

export const Route = createFileRoute("/_app/finances/")({
	validateSearch: FinancesSearchSchema,
	loader: async ({ context: { queryClient } }) =>
		queryClient.ensureQueryData(
			orpc.earnings.list.queryOptions({
				input: { limit: 20 },
			}),
		),
	head: () => ({
		meta: [{ title: "Finances - Biteasy" }],
	}),
	pendingComponent: FinancesPageSkeleton,
	component: RouteComponent,
});

function RouteComponent() {
	return <Finances />;
}
